<ng-container *transloco="let t; read: 'partials.preparations'">
  <div *ngIf="ac?.preparations?.length > 0 && !auth.isObserver()">
    <h2 class="label" [class.opened]="isOpen === true">
      <span class="pointer" (click)="toggleContainer()">{{ t('preparations') }}</span>
      <button *ngIf="isOpen !== true" pButton type="button" class="p-button-sm p-button-secondary p-button-text toggle" (click)="toggleContainer()" icon="pi pi-chevron-down" pTooltip="{{ t('expand') }}" tooltipPosition="bottom"></button>
      <button *ngIf="isOpen === true" pButton type="button" class="p-button-sm p-button-secondary p-button-text toggle" (click)="toggleContainer()" icon="pi pi-chevron-up" pTooltip="{{ t('collapse') }}" tooltipPosition="bottom"></button>
    </h2>
    <ng-container *ngIf="isOpen === true">
      <ul>
        <li *ngFor="let preparation of ac.preparations; index as i">
          <div class="p-grid p-nogutter" *ngIf="preparation.visible === true || auth.isModerator() || ac.isRunning()">
            <div class="p-col-fixed icon-number"><span>{{i + 1}}</span></div>
            <div class="p-col">
              <a (click)="openPreparation(preparation)" (keyup.enter)="openPreparation(preparation)" role="link" tabindex="0">{{preparation.exercisename}}: {{preparation.name}}</a><br>
              <span *ngIf="preparation.visible !== true && auth.isModerator() && !ac.isRunning()" class="small">{{ t('unlocked_for_candidate_at') }} {{preparation.visible_at | amLocal | amDateFormat: 'DD.MM.YYYY' }}</span>
            </div>
          </div>
          <div class="p-grid p-nogutter inactive" *ngIf="preparation.visible !== true && !auth.isModerator() && !ac.isRunning()">
            <div class="p-col-fixed icon"><fa-icon [icon]="faHourglassHalf" class="p-mr-2"></fa-icon></div>
            <div class="p-col">
              {{preparation.exercisename}}: {{preparation.name}}<br>
              <span class="small">{{ t('unlocked_at') }} {{preparation.visible_at | amLocal | amDateFormat: 'DD.MM.YYYY' }}</span>
            </div>
          </div>
        </li>
      </ul>
    </ng-container>
  </div>
</ng-container>
